// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"Menu_scroll-black__3U0k4","menu":"Menu_menu__qs3D_","afterpay":"Menu_afterpay__trt6U"};